module.exports = __webpack_public_path__ + "static/media/SCBaccounts.d53e5f19.svg";